import { StateCreator } from 'zustand';

import { SignUpState } from './types/SignUpState';

export const signUpStore: StateCreator<SignUpState> = () => ({
  firstName: '',
  lastName: '',
  primaryEmailAddress: '',
  primaryPhoneNumber: '',
});
